<template>
    <b-card>
        <b-table class="m-3" :items="orders" :fields="fields" :busy="tableLoading" small striped selectable select-mode="single"
            responsive @row-selected="onRowSelected" ref="recentOrdersTable" id="recentOrdersTable">
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <!-- <strong>{{ $translate('loading') }}</strong> -->
                </div>
            </template>

            <template #head(id)>
                <h6 class="pr-2" style="float: right; font-weight: bold">
                    {{ $translate('total') }}
                </h6>
            </template>

            <template #cell(type)="{ item }">{{ item.type.name }}</template>

            <template #cell(id)="{ item }">
                <h6 class="pr-2" style="float: right">
                    {{ item | getTotal | formatPrice }}
                </h6>
            </template>
        </b-table>
    </b-card>
</template>

<script>
export default {
    data() {
        return {
            tableLoading: false,
            orders: [],
        }
    },
    props: {
        customer_id: { type: Number, require: true },
        order_type_id: { type: Number, require: true },
        value: { type: [Number, null] },
    },
    filters: {
        getTotal(item) {
            return item.items.reduce((_total, item) => {
                const subtotal = item.quantity * item.price
                const tax_cost = (subtotal * item.tax_rate) / 100
                _total += subtotal + tax_cost
                return _total
            }, 0)
        },
        formatPrice: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
    },
    computed: {
        fields() {
            return [
                { key: 'reference_no', label: this.$translate('reference_no') },
                {
                    key: 'type',
                    label: this.$translate('type'),
                },
                { key: 'description', label: this.$translate('description') },
                {
                    key: 'updated_at',
                    label: this.$translate('date'),
                    formatter: value => {
                        const [date] = value.split(' ')
                        return date
                    },
                },
                'id'
            ]
        },
    },
    watch: {
        orders: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        value: function (val) {
            if (!val) {
                this.clearSelected()
            }
        },
    },
    mounted() {
        if (!this.value) {
            this.clearSelected()
        }
        this.doSearch()
    },
    methods: {
        clearSelected() {
            this.$refs.recentOrdersTable &&
                this.$refs.recentOrdersTable.clearSelected()
        },
        onRowSelected(orders) {
            console.log('orders', orders)
            if (orders.length > 0) {
                this.$emit('input', orders[0].id)
                this.$emit('set-items', orders[0].items)
            }
        },
        async doSearch() {
            const { customer_id, order_type_id } = this
            const page = 1
            const completed = 1
            const filters = {
                customer_id,
                order_type_id,
                completed,
                from_recent_orders: 1,
            }
            const query = ''
            this.tableLoading = true
            let orders = await this.$store.dispatch('orders/fetchDirect', {
                query,
                filters,
                page,
            })

            orders = orders.filter(x => x.items.length > 0)

            if (orders.length > 5) {
                orders = orders.slice(0, 5)
            }
            this.orders.splice(0, this.orders.length)
            this.orders.push(...orders)
        },
    },
}
</script>

<style>
    #recentOrdersTable tbody tr:hover{
       cursor: pointer; 
    }
</style>